import {Injectable} from '@angular/core';
import {PaymentRequestConfigurationModel} from '../paymentRequestConfiguration.model';
import {HttpModelConverter} from '../../../../../../../core/converter/httpModel.converter';
import {CommunicationConfigurationConverter} from '../../../../../../../communication/configuration/api/model/converter/communicationConfiguration.converter';

@Injectable()
export class PaymentRequestConfigurationConverter extends HttpModelConverter<PaymentRequestConfigurationModel> {

    constructor(private communicationConfigurationConverter: CommunicationConfigurationConverter) {
        super();
    }

    protected createInstance(): PaymentRequestConfigurationModel {
        return new PaymentRequestConfigurationModel();
    }

    protected enrichObject(result: PaymentRequestConfigurationModel, src: PaymentRequestConfigurationModel) {
        result.communicationConfiguration = this.communicationConfigurationConverter.convert(src.communicationConfiguration);
    }
}
